import React, { useEffect } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import ContactIllustration from "../Assets/Illustrations/ContactPageIllustration.png";
import ContactForm from "../components/ContactUsComps/ContactForm/ContactForm";
import usePageMeta from "../Helpers/usePageMeta";
import BookCallButton from "../components/BookCallButton/BookCallButton";

const Contact = () => {
  usePageMeta({
    title: "Contact Us | TZ Creation",
    description:
      "Get in touch with TZ Creation -- request a quote or ask about your web design, development or IT project.",
    path: "/contact-us",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="content mt-md-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="row justify-content-center">
                <div className="col-md-6">
                  <h3 className="heading mb-2">Get in Touch</h3>
                  <p className="caption">
                    Please provide all the details and we will contact you as
                    soon as possible.
                  </p>

                  <div className="my-4">
                    <p className="font-w300 text-grey mb-2">
                      Prefer to talk it through? Pick a time that suits you.
                    </p>
                    <BookCallButton />
                  </div>

                  <div>
                    <img
                      src={ContactIllustration}
                      alt="Contact illustration"
                      className="img-fluid"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <ContactForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
